import React, { useState, useEffect, useRef } from 'react';

import './dnd.css'
import AppNode from './AppNode';

import ReactFlow, {
    ReactFlowProvider,
    Controls, MiniMap, Background,
    setInteraction
  } from 'react-flow-renderer';  

  import RegularNode from './RegularNode';
  import customConnectionLine from './customConnectionLine';
  import getFields from './ActionFields';
  

  
  const edgeStyle = {
    // stroke: '#9999ff',
    strokeWidth:1.7,
    // strokeOpactiy:0.1

  };



export default function VisualAppFlow(props)
{


    const [entityName, setEntityName] = useState('newbot')
    const [selectedElement, setSelectedElement] = useState(null)

    const [fromElement, setFromElement] = useState('1')
    const [toElement, setToElement] = useState('2')

    const onElementClick = (event, element) => {
      event.preventDefault();
      console.log("Click")
      setSelectedElement(element)
  }

    
  
    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);

    const onLoad = (_reactFlowInstance) =>
      setReactFlowInstance(_reactFlowInstance);
  
    const updateProperties = (properties) => {
        selectedElement.data.attributes = properties

    }


    const nodeTypes = {
      AppNode: AppNode,
      RegularNode:RegularNode,
    };



    const secondsToMin =(seconds)=>{
      seconds = Math.floor( seconds );
      var mins = seconds/60
      if (mins == 0) return seconds

      mins = Math.floor( mins );
      return mins + ' minutes, ' + (seconds % 60) + ' seconds' 
    }
        
    const renderMain = () => {
      // console.log(props.appSet)
      var entity = document.getElementById('entity');

      if (entity != null)
      entity.setAttribute('value', entityName)

      return (

        <div className='cont'>
        <div className='visualflow'>
          <div style={{align:'center'}} className='taskname'> <h3  >Task Name -  {props.currentTaskName}</h3></div>

          
          <div className="taskcard">            
            {/* <h4>Total time: {secondsToMin(props.totalTime)}</h4> */}

            <h4>App Count : {props.appSet.size}</h4>
            <h4>App Hops : {props.appHops}</h4>

            <h4>Most used App: {props.mostTimeSpentApp}</h4>
            <h4>Most time spent : {secondsToMin(props.mostTimeSpent)}</h4>

          </div>
          <div className='designer'>
          <ReactFlow
          style={style}
          elements={props.data}
          connectionLineComponent={customConnectionLine}
          nodeTypes={nodeTypes}
          onLoad={onLoad}
          onElementClick={onElementClick}
          nodesDraggable={false}
          onlyRenderVisibleElements={true}
          panOnScroll={true}
          >

    
          {/* <MiniMap/> */}
          <Controls 
                    showInteractive={false}

          />

          <Background variant="dots" color="gray" gap={10} /> 

        </ReactFlow>
        </div>
        </div>

    </div>
    );




    }  
  
    const changeTitle = (event) => {
      console.log("clicked on entity")
      var entity = document.getElementById('entity')
      var entity2 = document.getElementById('entity2')

      entity.setAttribute('style', 'visibility:hidden')
      entity2.setAttribute('type', 'text') 
      
      console.log("enabled input")

    }  

    const onChange=(event)=>{
      
      setEntityName(event.target.value);
      console.log(entityName)
    }

    const onFocusOut=(event) => {
      console.log("focus lost")
      var entity = document.getElementById('entity')
      var entity2 = document.getElementById('entity2')
      entity.setAttribute('style', '')
      entity2.setAttribute('type', 'hidden') 
      console.log(entityName)
      entity.setAttribute('innerHtml',  entityName)

    }

    const style = {
        width: '100%',
        height: 700
      };



      
      
      return (
      <div className="cont">


      <ReactFlowProvider>

      <div className="reactflow-wrapper" ref={reactFlowWrapper}>

      {/* <div className="toolbar">

          {toolbar()}
      </div> */}

      {/* <div className = 'tabtitlepd'>
            {props.title + ' - ' } 
            <label id = 'entity'  onClick={changeTitle}>{entityName}</label>
            <input type ='hidden' value={entityName}  onChange={onChange} id = 'entity2'  onBlur={onFocusOut}></input>
      </div> */}
      {renderMain()}

      </div>
      </ReactFlowProvider>

      </div>
      );
}
